import React from 'react'
import { Modal } from 'antd'

type TimeIsUpModalProps = {
  timeIsUp: boolean
}

const TimeIsUpModal: React.FC<TimeIsUpModalProps> = ({ timeIsUp }) => {
  return (
    <Modal
      centered
      title={'Zeit abgelaufen'}
      open={timeIsUp}
      footer={[]} // TODO: Button to display results even though time is up
    >
      <p>
          Die Zeit ist abgelaufen.
      </p>
      <p>
          Sie können die Seite nun schließen.
      </p>
    </Modal>
  )
}

export default TimeIsUpModal